<template>
	<div v-editable="blok" class="flex text-[15px] lg:leading-none items-center">
		<nuxt-link
			:to="link"
			class="nav-link nav-link-cms lg:py-5 lg:px-2.5 lg:hover:underline"
			@click="closeMobileMenu"
		>
			{{ blok.name }}
		</nuxt-link>
	</div>
</template>

<script setup lang="ts">
import type { BlokMenuLink } from "~/types/storyblok/storyblok";

interface Props {
	blok: BlokMenuLink;
}
const { blok } = defineProps<Props>();

const localePath = useLocalePath();
const { resolveLink } = useStoryblokLink();
const link = computed(() => resolveLink(blok?.link) || localePath("/"));

const emit = defineEmits(["closeMobileMenu"]);
const closeMobileMenu = () => {
	emit("closeMobileMenu");
};
</script>
